import React, { useCallback, useMemo, useState } from 'react';
import { Badge, BlockStack, Button, Divider, IndexTable, Link, Text } from '@shopify/polaris';
import { useNotification } from 'context/NotificationContext';
import __helpers from 'helpers/index';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import AccountingInvoicePreviewModal, { PreviewInvoiceData } from './AccountingInvoicePreviewModal';
import { TypedTripManifest, useMutateUpdateTrip_manifest } from 'queries/trip_manifest.query';
import helpers from 'helpers/index';
import { useField, useForm } from '@shopify/react-form';
import __ from 'languages/index';
import { useMutateVehicleLogSync } from 'queries/vehicle_log.query';
import {
  ENUM_INVOICE_STATUS,
  useMutateDeleteInvoices,
  useMutateExportInvoices,
  useMutatePreviewInvoices,
  useMutateSignInvoices,
} from 'queries/invoices.query';
import { useGetInvoices } from 'queries/invoices.query';

export default function AccountingShell({ tripManifestData }: { tripManifestData: TypedTripManifest }) {
  // const [allowExportInvoice, setAllowExportInvoice] = useState(false);

  const { mutateAsync: vehicleLogSync, isPending: loadingSyncVehicleLog } = useMutateVehicleLogSync();
  const vehicleLogSyncCallback = useCallback(async (trip_manifest_id: any) => {
    try {
      await vehicleLogSync(trip_manifest_id);
    } catch (e) {}
  }, []);

  // useEffect(() => {
  //   if (!tripManifestData) return;
  //   let ALLOWED = true;
  //   if (tripManifestData?.total_occupied_seats < 1) {
  //     /** vé gửi hàng không tính vào số ghế, cho nên phải khóa lại kẻo 1 chuyến có chỉ 1 hàng thì không hoạt động */
  //     // ALLOWED = false;
  //   }
  //   if (tripManifestData?.total_fare < 1) {
  //     ALLOWED = false;
  //   }
  //   if (tripManifestData?.is_exported_invoice === 1) {
  //     ALLOWED = false;
  //   }
  //   setAllowExportInvoice(ALLOWED);
  // }, [tripManifestData]);

  const { data: tripManifestInvoices, isLoading: isLoadingInvoices } = useGetInvoices({
    'trip_manifest_invoice.trip_manifest_id': tripManifestData.id,
  });
  const { mutateAsync: deleteInvoiceMutation, isPending: DeleteLoading } = useMutateDeleteInvoices();
  const { mutateAsync: signInvoiceMutation, isPending: SignLoading } = useMutateSignInvoices();
  const { mutateAsync: exportInvoiceMutation, isPending: ExportLoading } = useMutateExportInvoices();

  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [previewData, setPreviewData] = useState<PreviewInvoiceData[] | null>(null);
  const [previewRequest, setPreviewRequest] = useState<any>(null);

  const formatInvoiceDate = useCallback((createdAt?: string) => {
    if (!createdAt) return '-';
    const parsed = new Date(Number(createdAt));
    if (Number.isNaN(parsed.getTime())) return createdAt;
    return parsed.toLocaleString('vi-VN');
  }, []);

  const invoicesWithTools = useMemo(() => {
    if (!tripManifestInvoices || __helpers.isEmpty(tripManifestInvoices)) return [];

    return tripManifestInvoices?.body?.records.map((tripmanifestInvoice) => {
      const isDraft = tripmanifestInvoice?.LoaiHDon === 0;
      const isSigned = tripmanifestInvoice?.is_signed === 1;
      return {
        ...tripmanifestInvoice,
        isDraft,
        isSigned,
      };
    });
  }, [tripManifestInvoices]);

  const { addNotification } = useNotification();
  const { showDeleteConfirm } = useDeleteConfirm();

  const { mutateAsync: getPreviewData, isPending: loadingPreview } = useMutatePreviewInvoices();
  const getPreviewDataCallback = useCallback(
    async (trip_manifest_id) => {
      try {
        const response = await getPreviewData(trip_manifest_id);
        setPreviewRequest(trip_manifest_id);
        setPreviewData(response);
        setPreviewModalOpen(true);
      } catch (e) {}
    },
    [addNotification, getPreviewData]
  );

  const handleExportInvoice = useCallback(async () => {
    if (!previewRequest) return;
    try {
      await exportInvoiceMutation(previewRequest);
      addNotification('info', 'Tạo hóa đơn thành công!');
      setPreviewModalOpen(false);
    } catch (e) {}
  }, [addNotification, exportInvoiceMutation, previewRequest]);

  const [currentDeletingInvoice, setCurrentDeletingInvoice] = useState(null);
  const [currentSignInvoice, setCurrentSignInvoice] = useState(null);
  const deleteInvoiceCallback = useCallback(async (invoice_id: any) => {
    const confirmed = await showDeleteConfirm(
      'Xóa hóa đơn này?',
      'BẠN ĐANG XÓA HÓA ĐƠN! Chỉ có hóa đơn nháp mới được phép xóa! Hành động này không thể khôi phục. '
    );
    if (!confirmed) return;
    setCurrentDeletingInvoice(invoice_id);
    try {
      await deleteInvoiceMutation(invoice_id);
      addNotification('info', 'Xóa hóa đơn thành công!');
    } catch (e) {
      addNotification('error', 'Không thể xóa hóa đơn này!');
    } finally {
      setCurrentDeletingInvoice(null);
    }
  }, []);

  const signInvoiceCallback = useCallback(async (tripManifestInvoiceData: any) => {
    const confirmed = await showDeleteConfirm(
      'Ký hóa đơn này?',
      'BẠN ĐANG KÝ MỘT HÓA ĐƠN! Bạn nên nhớ, hành động này không thể hoàn tác, việc hoàn tác phải được LẬP BIÊN BẢN. HÃY KIỂM TRA KỸYYYYYYYYYYYYY',
      {
        customAction: {
          content: 'Xem lại',
          onAction: () => {
            window.open(tripManifestInvoiceData.urlDownloadPDF, '_blank');
          },
        },
      }
    );
    if (!confirmed) return;

    setCurrentSignInvoice(tripManifestInvoiceData.invoice_id);
    try {
      await signInvoiceMutation(tripManifestInvoiceData.invoice_id);
      addNotification('info', 'Ký hóa đơn thành công!');
    } catch (e) {
      // addNotification('error', 'Không thể ký hóa đơn này!');
    } finally {
      setCurrentSignInvoice(null);
    }
  }, []);

  const rowMarkup = invoicesWithTools?.map((tripManifestInvoiceData, index) => {
    const displayId =
      tripManifestInvoiceData?.maTraCuu || tripManifestInvoiceData?.maSoHDon || tripManifestInvoiceData?.invoice_id || `invoice-${index + 1}`;
    const statusBadge = tripManifestInvoiceData.isDraft ? (
      <Badge>Chưa chính thức</Badge>
    ) : (
      <Badge tone="critical-strong" progress="complete">
        Chính thức
      </Badge>
    );
    const signedBadge = tripManifestInvoiceData.isSigned ? (
      <Badge tone="attention-strong" progress="complete">
        Đã ký
      </Badge>
    ) : (
      <Badge>Chưa ký</Badge>
    );
    const canDelete = !tripManifestInvoiceData.isSigned;
    const canSign = !tripManifestInvoiceData.isSigned;
    const isDeleteLoading = DeleteLoading && currentDeletingInvoice === tripManifestInvoiceData.invoice_id;
    const isSignLoading = SignLoading && currentSignInvoice === tripManifestInvoiceData.invoice_id;
    const manyOrdersHash = tripManifestInvoiceData?.order_to_invoice.map((a) => a.order_id.toString());

    return (
      <IndexTable.Row id={tripManifestInvoiceData.invoice_id || displayId} key={displayId} position={index}>
        <IndexTable.Cell>
          <Text variant="bodyMd" fontWeight="bold" as="span">
            {tripManifestInvoiceData.invoice_status === ENUM_INVOICE_STATUS.CANCEL ? (
              tripManifestInvoiceData.invoice_id
            ) : (
              <Link url={process.env.REACT_APP_BACKEND_URL + `/invoices/view_pdf/${tripManifestInvoiceData.maTraCuu}` || '#'} target="_blank">
                {tripManifestInvoiceData.invoice_id}
              </Link>
            )}
          </Text>
        </IndexTable.Cell>
        <IndexTable.Cell>
          {tripManifestInvoiceData.invoice_status === ENUM_INVOICE_STATUS.CANCEL ? (
            <Text as="p">
              {tripManifestInvoiceData.shDon} / {manyOrdersHash}
            </Text>
          ) : (
            <Link
              onClick={() => {
                window.location.hash = String(manyOrdersHash);
              }}
            >
              {tripManifestInvoiceData.shDon} / {manyOrdersHash}
            </Link>
          )}
        </IndexTable.Cell>
        <IndexTable.Cell>{tripManifestInvoiceData?.mccqt || '--'}</IndexTable.Cell>
        <IndexTable.Cell>{helpers.formatNumber(tripManifestInvoiceData?.TgTTTBSo)}</IndexTable.Cell>
        <IndexTable.Cell>{tripManifestInvoiceData.TaxType}</IndexTable.Cell>
        <IndexTable.Cell>{helpers.trimMiddleString(tripManifestInvoiceData.NMua_HVTNMHang || tripManifestInvoiceData.NMua_Ten)}</IndexTable.Cell>
        <IndexTable.Cell>{statusBadge}</IndexTable.Cell>
        <IndexTable.Cell>{formatInvoiceDate(tripManifestInvoiceData.createdAt)}</IndexTable.Cell>
        <IndexTable.Cell>{tripManifestInvoiceData?.trip_manifest_invoice?.trip_manifest?.vehicle?.license_plate || '-'}</IndexTable.Cell>
        <IndexTable.Cell>{signedBadge}</IndexTable.Cell>
        <IndexTable.Cell>
          {canDelete && (
            <Button tone="critical" loading={isDeleteLoading} onClick={() => deleteInvoiceCallback(tripManifestInvoiceData.invoice_id)}>
              Xóa
            </Button>
          )}
          &nbsp;
          {canSign && (
            <Button tone="success" loading={isSignLoading} onClick={() => signInvoiceCallback(tripManifestInvoiceData)}>
              Ký và phát hành
            </Button>
          )}
        </IndexTable.Cell>
      </IndexTable.Row>
    );
  });

  const { mutateAsync: updateTripManifest } = useMutateUpdateTrip_manifest();
  const useFields = {
    odo_from: useField<number>({
      value: tripManifestData?.odo_from ?? 0,
      validates: [
        (inputVal) => {
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
        },
      ],
    }),
    odo_to: useField<number>({
      value: tripManifestData?.odo_to ?? 0,
      validates: [
        (inputVal) => {
          if (!helpers.isNumber(inputVal)) return 'Phải là một số hợp lệ.';
        },
      ],
    }),
  };

  const {
    fields,
    submit,
    dirty,
    reset: resetForm,
  } = useForm({
    fields: useFields,

    async onSubmit(values) {
      try {
        await updateTripManifest({
          id: tripManifestData.id,
          odo_from: helpers.parseNumeric(values.odo_from),
          odo_to: helpers.parseNumeric(values.odo_to),
        });
        addNotification('info', 'Cập nhật ODO chuyến đi thành công!');
      } catch (e: any) {
        if (e.params !== undefined) {
          if (e.params.field !== undefined) {
            useFields[e.params.field].setError(__('check_this_field_again'));
          }
        }
      }
      return { status: 'success' };
    },
  });

  return (
    <BlockStack gap="400">
      <Text as="h3" variant="headingLg">
        Khởi tạo
      </Text>
      <Text as="p" tone="subdued">
        Sau khi xuất hết hóa đơn, bảng kê hành khách và nhật trình sẽ cho phép tải về.
      </Text>
      <Text as="p" tone="subdued">
        Sau khi xuất hết vé, Nhật trình và Hóa đơn sẽ gắn liền với xe{' '}
        <Link url={`/vehicle/${tripManifestData?.vehicle_id}`}>
          <strong>{tripManifestData?.vehicle?.license_plate}</strong>
        </Link>
        , vui lòng không chỉnh sửa sau khi xuất hóa đơn.
      </Text>
      <br />

      <Button
        variant="secondary"
        disabled={tripManifestData.is_exported_invoice !== 1}
        loading={loadingSyncVehicleLog}
        onClick={async () => {
          vehicleLogSyncCallback(tripManifestData.id);
        }}
      >
        Tạo nhật trình và bảng kê
      </Button>

      {/* <Form onSubmit={submit}>
        <FormLayout>
          <FormLayout.Group condensed>
            <TextField
              label="ODO ban đầu"
              {...useFields.odo_from}
              autoComplete="off"
              value={helpers.formatNumberWithCommas(fields.odo_from.value)}
              onChange={(a) => fields.odo_from.onChange(helpers.parseNumeric(a))}
            />
            <TextField
              label="ODO cuối"
              autoComplete="off"
              {...useFields.odo_to}
              value={helpers.formatNumberWithCommas(fields.odo_to.value)}
              onChange={(a) => fields.odo_to.onChange(helpers.parseNumeric(a))}
            />
          </FormLayout.Group>
          <Button disabled={!dirty} onClick={submit}>
            Cập nhật ODO
          </Button>
        </FormLayout>
      </Form> */}

      <Divider />
      <Text as="h3" variant="headingLg">
        Hóa đơn
      </Text>

      <Button
        variant="secondary"
        // disabled={!allowExportInvoice} // không cần tắt, lỡ có thêm vé thì làm thế nào? Hờ hờ hờ
        loading={loadingPreview}
        onClick={async () => {
          setPreviewRequest(tripManifestData.id);
          getPreviewDataCallback(tripManifestData.id);
        }}
      >
        Xem trước hóa đơn &amp; tạo
      </Button>
      <AccountingInvoicePreviewModal
        open={previewModalOpen}
        data={previewData}
        loading={ExportLoading}
        onClose={() => setPreviewModalOpen(false)}
        onCreateInvoice={handleExportInvoice}
      />
      {tripManifestInvoices?.totalItems > 0 ? (
        <>
          <Text as="p">Danh sách hóa đơn</Text>
          <IndexTable
            resourceName={{
              singular: 'Hóa đơn',
              plural: 'Hóa đơn',
            }}
            emptyState={<p>Chưa thấy hóa đơn nào!</p>}
            headings={[
              { title: 'ID' },
              { title: 'Số hóa đơn' },
              { title: 'Mã CQT' },
              { title: 'Tổng tiền' },
              { title: 'Loại HD' },
              { title: 'Ng nhận' },
              { title: 'Tình trạng' },
              { title: 'Ngày' },
              { title: 'Xe' },
              { title: 'Ký' },
              { title: '-' },
            ]}
            itemCount={tripManifestInvoices?.totalItems || 0}
            selectable={false}
            loading={isLoadingInvoices}
          >
            {rowMarkup}
          </IndexTable>
        </>
      ) : (
        <></>
      )}
    </BlockStack>
  );
}

